import { downloadPDF, emailPDF } from '@/helper/apicalls';

import { baseURL } from './const';

export async function printAction({ params }: any) {
  // eslint-disable-next-line unicorn/prefer-ternary
  if (params.id) {
    return downloadPDF(baseURL, params.id, 'LIME_MixerReport_' + params.id);
  } else {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }
}

export async function emailAction({ request, params }: any) {
  const body = Object.fromEntries(await request.formData());
  // eslint-disable-next-line unicorn/prefer-ternary
  if (params.id) {
    return emailPDF(baseURL, params.id, body);
  } else {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }
}
